module.exports = "https://coursera_assets.s3.amazonaws.com/images/3965428b288078a92c4e881713caee10.svg";